import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M440-663 230-452q-12 12-28 12-17 0-29-12-12-11-11-28 0-16 12-28l278-278q6-6 13-10 7-3 15-3t15 3q7 4 13 10l279 278q12 13 12 29t-12 27q-12 12-28 12t-28-12L520-663v478q0 16-12 28-11 11-28 11t-28-11q-12-12-12-28v-478Z"/>',
  f: '<path d="M440-663 230-452q-12 12-28 12-17 0-29-12-12-11-11-28 0-16 12-28l278-278q6-6 13-10 7-3 15-3t15 3q7 4 13 10l279 278q12 13 12 29t-12 27q-12 12-28 12t-28-12L520-663v478q0 16-12 28-11 11-28 11t-28-11q-12-12-12-28v-478Z"/>',
};

export default data;
